/* ============================================================================
   PAGE D'ACCUEIL — message de bienvenue
   À installer dans : assets/accueil.js
   Appelé depuis layout/theme.liquid.

   Parti pris : pas de fenêtre modale, rien à fermer à la main. Un bandeau
   discret glisse depuis le bas à droite, reste quelques secondes, puis
   s'efface seul. Il n'apparaît qu'une fois par visite.
   ============================================================================ */

(function () {
  'use strict';

  // ---------------------------------------------------------------------
  // Réglages
  // ---------------------------------------------------------------------

  var MESSAGE_TITRE = 'Bienvenue chez nous';
  var MESSAGE_TEXTE = 'Des coffrets composés avec des producteurs francs-comtois.';
  var DELAI_AVANT = 1200;   // temps avant l'apparition
  var DUREE_VISIBLE = 6000; // temps d'affichage avant effacement
  var CLE_SESSION = 'lctc-bienvenue';

  // ---------------------------------------------------------------------

  var surAccueil =
    window.location.pathname === '/' ||
    window.location.pathname === '' ||
    /^\/[a-z]{2}(-[a-z]{2})?\/?$/i.test(window.location.pathname);

  if (!surAccueil) return;

  var reduced =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Une seule apparition par session de navigation
  var dejaVu = false;
  try {
    dejaVu = window.sessionStorage.getItem(CLE_SESSION) === '1';
  } catch (e) {
    dejaVu = false;
  }
  if (dejaVu) return;

  function injecterStyles() {
    if (document.getElementById('accueil-bienvenue-styles')) return;
    var style = document.createElement('style');
    style.id = 'accueil-bienvenue-styles';
    style.textContent = [
      '#accueil-bienvenue {',
      '  position: fixed;',
      '  right: 20px;',
      '  bottom: 20px;',
      '  z-index: 9996;',
      '  max-width: 320px;',
      '  display: flex;',
      '  align-items: flex-start;',
      '  gap: 12px;',
      '  padding: 14px 18px;',
      '  border-radius: 12px;',
      '  background: #394a2e;',
      '  color: #f6f3ea;',
      '  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.18);',
      '  opacity: 0;',
      '  transform: translateY(16px);',
      '  transition: opacity 420ms ease, transform 420ms cubic-bezier(0.22, 0.75, 0.35, 1);',
      '  pointer-events: none;',
      '}',
      '#accueil-bienvenue.est-visible {',
      '  opacity: 1;',
      '  transform: translateY(0);',
      '}',
      '#accueil-bienvenue .ab-barre {',
      '  flex-shrink: 0;',
      '  width: 3px;',
      '  align-self: stretch;',
      '  border-radius: 2px;',
      '  background: #c1b404;',
      '}',
      '#accueil-bienvenue .ab-titre {',
      '  margin: 0 0 2px;',
      '  font-size: 14px;',
      '  font-weight: 700;',
      '  line-height: 1.3;',
      '}',
      '#accueil-bienvenue .ab-texte {',
      '  margin: 0;',
      '  font-size: 13px;',
      '  line-height: 1.4;',
      '  color: rgba(246, 243, 234, 0.85);',
      '}',
      '@media screen and (max-width: 749px) {',
      '  #accueil-bienvenue {',
      '    right: 12px;',
      '    left: 12px;',
      '    bottom: 12px;',
      '    max-width: none;',
      '  }',
      '}',
      '@media (prefers-reduced-motion: reduce) {',
      '  #accueil-bienvenue {',
      '    transition: opacity 200ms ease;',
      '    transform: none;',
      '  }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function afficher() {
    injecterStyles();

    var boite = document.createElement('div');
    boite.id = 'accueil-bienvenue';
    boite.setAttribute('role', 'status');
    boite.setAttribute('aria-live', 'polite');

    var barre = document.createElement('span');
    barre.className = 'ab-barre';

    var corps = document.createElement('div');

    var titre = document.createElement('p');
    titre.className = 'ab-titre';
    titre.textContent = MESSAGE_TITRE;

    var texte = document.createElement('p');
    texte.className = 'ab-texte';
    texte.textContent = MESSAGE_TEXTE;

    corps.appendChild(titre);
    corps.appendChild(texte);
    boite.appendChild(barre);
    boite.appendChild(corps);
    document.body.appendChild(boite);

    // Un cycle de rendu avant d'animer, sans quoi la transition est ignorée
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        boite.classList.add('est-visible');
      });
    });

    try {
      window.sessionStorage.setItem(CLE_SESSION, '1');
    } catch (e) { /* navigation privée : le message reparaîtra */ }

    window.setTimeout(function () {
      boite.classList.remove('est-visible');
      window.setTimeout(function () {
        if (boite.parentNode) boite.parentNode.removeChild(boite);
      }, 500);
    }, DUREE_VISIBLE);
  }

  function demarrer() {
    window.setTimeout(afficher, reduced ? 300 : DELAI_AVANT);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();